import A11yDialog from 'a11y-dialog';
import { Cookie } from './cookies';

export function ModalPopup() {
    const popup = document.querySelector('.popup');
    if (popup == null) return false;

  // Grab the ID of the popup so we can check the cookie
    const popupId = popup.id;

  //Check to see if our cookie exist
  let modalSeen = Cookie.get('showModal' + popupId);

  if (modalSeen) return;

  Cookie.set('showModal' + popupId, 'shown', { path: '/', days: 365 })

  const dialogEl = document.querySelector('.popup');
  const dialog = new A11yDialog(dialogEl);
  
  // Event listeners to add/remove class from body
  dialog.on('show', function (dialogEl) {
    document.querySelector('body').classList.add('no-scroll')
  })

  dialog.on('hide', function (dialogEl) {
    document.querySelector('body').classList.remove('no-scroll')
  })

  //Show the dialog
  dialog.show()

}
